import { render, staticRenderFns } from "./fenhong.vue?vue&type=template&id=ec42ce0e&scoped=true&"
import script from "./fenhong.vue?vue&type=script&lang=js&"
export * from "./fenhong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec42ce0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/thScoreShop/thScoreAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec42ce0e')) {
      api.createRecord('ec42ce0e', component.options)
    } else {
      api.reload('ec42ce0e', component.options)
    }
    module.hot.accept("./fenhong.vue?vue&type=template&id=ec42ce0e&scoped=true&", function () {
      api.rerender('ec42ce0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/systemCreator/systemConfig/bonusConfig/bounsCond/fenhong.vue"
export default component.exports